import Request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取产品列表
  static getQualification(params, data) {
    return Request({
      url: 'es/item/query/browse/page-info',
      host: config.HOST_SEARCH,
      method: 'post_json',
      params,
      data
    });
  }

  // 类目列表
  static getCatalogList(params) {
    return Request({
      url: `item/catalog/tree/children`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取分页列表
   */
  static getPage(options) {
    return Request({
      url: options.url,
      host: config.HOST_MALL,
      method: options.method || 'post_json',
      params: options.params,
      data: options.data
    });
  }

  /**
   * 查询商品列表
   */
  static getProductList(id, params) {
    return Request({
      url: `promotion/activity/id/${id}${params}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 查询促销活动状态 活动进行中 返回1 其它0
   */
  static getActivity(id) {
    return Request({
      url: `promotion/activity/status/${id}`,
      host: config.HOST_MALL
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/Qualification/QualificationServ.js